import React from 'react'
import "./testinomials.css"
const Testinomials = () => {
  return (
    <div className='contest'>
        <div className='left'>
        <p className='testi'>TESTINOMIALS</p>
        <h1>What Our Clients Say</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio, dolor quidem impedit esse placeat molestiae amet perferendis a laudantium ea debitis consectetur! Praesentium tenetur voluptate adipisci deleniti numquam consequatur ab!</p>

        </div>
        <div className="right">
            <h1>4.8</h1>
        
            <h2>Average Customer Rating</h2>
        </div>
    </div>
  )
}

export default Testinomials